const useComponents = (app) => {
  // 创建上下文
  const componentsContext = require.context('./com-components', true, /\.vue/)
  // 调用函数的keys方法获取到指定目录的下面文件路径
  componentsContext.keys().forEach((path) => {
    // console.log('path :>> ', path)
    const componentsName = path.split('/')[2].replace('.vue', '')
    // 调用上下文函数，根据path获取到组件函数
    const component = componentsContext(path)
    // 全局挂载
    // console.log('componentsName :>> ', componentsName)
    app.component(componentsName, component.default)
  })
}

export default useComponents
